import React, { useState } from 'react'
import styled from 'styled-components'

const ToggleButton = styled.div<{ expanded?: boolean }>`
  color: ${({ theme }) => theme.palette.giphyLightBlue};
  margin: 0 0 10px 0;
  font-weight: bold;
  cursor: pointer;

  &::after {
    content: ' ';
    display: inline-block;
    border-top: 7px solid transparent;
    border-bottom: 7px solid transparent;
    border-left: 7px solid ${({ theme }) => theme.palette.giphyLightBlue};
    vertical-align: middle;
    margin-left: 0.7rem;
    transform: translateY(-2px);
    transition: transform 0.4s ease-out;
    transform: ${(props) => (props.expanded ? 'rotate(90deg)' : 'rotate(0deg)')} translateY(-1px);
  }
`

const HiddenContent = styled.div<{ expanded?: boolean }>`
  transition: all 0.4s linear;
  max-height: ${(props) => (props.expanded ? '300px' : '0px')};
  overflow: hidden;
`

const AccordionContainer = styled.div`
  margin: 0 0 40px;
`

export const Accordion: React.FC = ({ children }) => {
  const [isExpanded, setExpanded] = useState(false)
  return (
    <AccordionContainer
      onClick={() => {
        setExpanded(!isExpanded)
      }}
    >
      <ToggleButton expanded={isExpanded}>Show More Details</ToggleButton>
      <HiddenContent expanded={isExpanded}>{children}</HiddenContent>
    </AccordionContainer>
  )
}
